import { resetCaptcha as reset, setIsCaptchaNeed } from 'entities/index';
import { useAppDispatch, useAppSelector } from 'shared/lib';

export const useInvisibleCaptcha = () => {
  const { token, captchaStatus, isCaptchaNeed } = useAppSelector(
    (state) => state.yaSmartCaptchaReducer,
  );

  const dispatch = useAppDispatch();

  const resetCaptcha = () => dispatch(reset());

  const removeCaptcha = () => dispatch(setIsCaptchaNeed(false));

  const addCaptcha = () => dispatch(setIsCaptchaNeed(true));

  return {
    token,
    resetCaptcha,
    captchaStatus,
    addCaptcha,
    removeCaptcha,
    isCaptchaNeed,
  };
};
